import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContentCont,
  ImageCont,
  Image,
  List,
  ListItem,
  Modal,
  Text,
  Title,
  Topic,
} from './IndividualReportDetailsModal.styles';
import { IIndividualStatesTopic, IWorkEnvironmentCategory } from '../../services/individualReport';

interface IIndividualReportCategoryModal {
  data: IWorkEnvironmentCategory | null;
  type: 'category';
  onClose: () => void;
}

interface IIndividualReportTopicModal {
  data: IIndividualStatesTopic | null;
  type: 'topic';
  onClose: () => void;
}

type TIndividualReportCategoryModal = IIndividualReportCategoryModal | IIndividualReportTopicModal;

const IndividualReportDetailsModal = React.forwardRef<
  HTMLDialogElement,
  TIndividualReportCategoryModal
>(({ data, type, onClose }, ref) => {
  const { t } = useTranslation();

  const { description, title } = data ?? {};

  return (
    <Modal {...{ ref }}>
      <Modal.Header onClick={onClose} />
      <Modal.Body>
        <ContentCont id="ContentCont">
          <Title id="Title" as="h2">{title}</Title>
          <Text as="p">{description}</Text>
          {type === 'category' ? (
            <>
              <Text>{t('results.report.modal.topics')}</Text>
              <List id="List">
                {data?.topics.map(topic => (
                  <ListItem key={topic}>
                    <Topic>{topic}</Topic>
                  </ListItem>
                ))}
              </List>
            </>
          ) : null}
        </ContentCont>
        <ImageCont id="ImageCont">
          <Image id="Image" />
        </ImageCont>
      </Modal.Body>
    </Modal>
  );
});

IndividualReportDetailsModal.displayName = 'IndividualReportDetailsModal';

export default IndividualReportDetailsModal;
